import { MeterReadsSummary, UsageSummary } from '@ovotech/energy-cx';
import { Col, Row } from '@ovotech/nebula';
import React from 'react';
import RowLoading from './RowLoading';
import { DisplayFlex, ErrorBoundary } from '@/src/components';
import {
  METER_READS_WIDGET_ERROR,
  USAGE_SUMMARY_WIDGET_ERROR,
} from '@/src/constants/error-section-ids';
import { useUsageWidgetVisibility } from '../../useUsageWidgetVisibility';

export const UsageAndMeterReadWidgets = () => {
  const { data, isLoading, isError } = useUsageWidgetVisibility();

  if (isLoading) return <RowLoading />;

  if (isError || !data) return null;

  if (data.showUsageWidget) {
    return (
      <Row isNested>
        <Col medium={6} as={DisplayFlex}>
          <ErrorBoundary errorId={USAGE_SUMMARY_WIDGET_ERROR}>
            <UsageSummary />
          </ErrorBoundary>
        </Col>
        <Col medium={6} as={DisplayFlex}>
          <ErrorBoundary errorId={METER_READS_WIDGET_ERROR}>
            <MeterReadsSummary />
          </ErrorBoundary>
        </Col>
      </Row>
    );
  }

  return null;
};
